import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import _ from 'lodash';
// import { useNotifications } from 'src/redux/actions/notifications';
import { useContext } from 'react';
import { AppContext } from 'src/components/app/contexts/appContext';
import { useDispatch } from 'react-redux';
import { hideSideMenu } from 'src/redux/actions/hub';

function withUseHooks(Component) {
  
  function ComponentWithHooksProp(props) {
    
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sourceQuery = searchParams.get("source");
    // const { data, refetch } = useNotifications();
    const { smallTalk } = useContext(AppContext);
    const queryObj = {};

    queryParams.forEach((value, key) => {
      if (_.has(queryObj, key)) {
        queryObj[key] = _.castArray(queryObj[key]).concat(value);
      } else {
        queryObj[key] = value;
      }
    });

    const locationObj = {
      pathname: location.pathname,
      search: _.get(location, 'search', ''),
      query: queryObj
    };

    const handleIntegrationsBackButton = () => {
      dispatch(hideSideMenu(false));
      setTimeout(() => {
        if(sourceQuery){
               navigate(`/settings/${sourceQuery}`);
        } else {
              navigate("/settings/integrations");
        }
      },300)
    }

    return <Component {...props} handleIntegrationsBackButton={handleIntegrationsBackButton} navigate={navigate} params={params} location={locationObj} pathname={location.pathname}  smallTalk={smallTalk}
    // notifications={data} fetchNotifications={refetch} 
    />;
  }
  return ComponentWithHooksProp;
}

export default withUseHooks;